import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Bell, Trash2 } from "lucide-react";
import { toast } from "sonner";

export function describeSearch(s) {
  return [s.q, s.max_price ? `under $${Number(s.max_price).toLocaleString()}` : null, s.city, s.min_year ? `${s.min_year}+` : null].filter(Boolean).join(" · ") || "All cars";
}

export default function SavedSearches() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/saved-searches").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const del = async (id) => { try { await api.delete(`/saved-searches/${id}`); toast.success("Alert removed"); load(); } catch { toast.error("Failed"); } };
  if (items.length === 0) return null;
  return (
    <div data-testid="saved-searches-section">
      <h2 className="font-display text-xl font-bold mb-3 flex items-center gap-2"><Bell className="w-5 h-5 text-cyan-400" /> Price-drop alerts</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map((s) => (
          <div key={s.search_id} data-testid={`saved-search-${s.search_id}`} className="flex items-center gap-3 p-3 rounded-xl bg-[#131722] border border-slate-800">
            <div className="min-w-0 flex-1"><p className="font-semibold truncate">{describeSearch(s)}</p><p className="text-xs text-slate-400">{s.matches} matching now · daily email on new cars & drops ≥ $100</p></div>
            <Button size="sm" variant="ghost" onClick={() => del(s.search_id)} data-testid={`delete-search-${s.search_id}`} className="text-slate-400 hover:text-red-300"><Trash2 className="w-4 h-4" /></Button>
          </div>
        ))}
      </div>
    </div>
  );
}
